module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/top-img.12703c9d.png";